import { readonly } from 'vue'

export default readonly([
  {
    label: 'CSV',
    value: 'csv',
    configurables: {
      delimiter: true,
      referenceType: true,
    },
    mappingType: 'reference',
    mappingOptions: [
      {
        type: 'column',
        config: {
          label: 'CSV column position (starting from 1)',
          input: 'number',
          props: {
            min: 1,
            max: 100,
          },
        },
      },
      {
        type: 'header',
        config: {
          label: 'CSV header value',
          input: 'text',
          props: {
            maxlength: 100,
          },
        },
      },
    ],
  },
  {
    label: 'JSON',
    value: 'json',
    configurables: {
      rootPath: true,
    },
    mappingType: 'fixed',
    mappingOption: {
      label: 'JSON field',
      input: 'text',
      props: {
        maxlength: 100,
      },
    },
  },
])
